import {
	getController,
	apiService as Service,
	type HpRequestOptional,
} from '@/services/service'

const url = 'mailservers'

export const mailserverService = {
	...getController<
		Api.Mailserver,
		Api.MailserverPostInput,
		Api.MailserverPostInput
	>(url),
	attachSet: (id: number, data?: HpRequestOptional) =>
		Service.put({ url: `${url}/set/${id}`, ...data }),
	test: (data: HpRequestOptional) => Service.post({ url: `${url}/test`, ...data }),
}

export default mailserverService
